module.exports = __webpack_public_path__ + "media/images/pages/sample_brands/brand-dropbox-85c77402d688714b2bc1903cae6b1f08.png";